import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GridOnIcon from '@mui/icons-material/GridOn';
import LogoutIcon from '@mui/icons-material/Logout';
import AddIcon from '@mui/icons-material/Add';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import SubtitlesOffIcon from '@mui/icons-material/SubtitlesOff';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import SettingsIcon from '@mui/icons-material/Settings';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SearchIcon from '@mui/icons-material/Search';
import BeenhereOutlinedIcon from '@mui/icons-material/BeenhereOutlined';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import AppsIcon from '@mui/icons-material/Apps';
import { FaList } from 'react-icons/fa';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TimeIcon from '@mui/icons-material/AccessTime';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import TaskIcon from "@mui/icons-material/Task";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import NoteIcon from '@mui/icons-material/EditNote';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import MinimizeIcon from '@mui/icons-material/Minimize';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AllInclusiveOutlinedIcon from '@mui/icons-material/AllInclusiveOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DeleteIcon from "@mui/icons-material/Delete";
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import AddIcCallOutlinedIcon from '@mui/icons-material/AddIcCallOutlined';
import AddTaskOutlinedIcon from '@mui/icons-material/AddTaskOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import WalletOutlinedIcon from '@mui/icons-material/WalletOutlined';
import RepeatOnOutlinedIcon from '@mui/icons-material/RepeatOnOutlined';
export const WSIcons = {
  Edit: EditOutlinedIcon,
  Home: HomeIcon,
  Person: PersonIcon,
  TrendingUp: TrendingUpIcon,
  Annual: DashboardIcon,
  Masters: GridOnIcon,
  LogOut: LogoutIcon,
  AddIcon: AddIcon,
  UserGroup: GroupAddIcon,
  RolesIcon: RoomPreferencesIcon,
  ManageAccountIcon: ManageAccountsIcon,
  MedicalServicesIcon: MedicalServicesIcon,
  WithoutPay: SubtitlesOffIcon,
  ArrowRight: KeyboardArrowRightIcon,
  PersonOffIcon: PersonOffIcon,
  SettingsIcon: SettingsIcon,
  HolidayVillageIcon: HolidayVillageIcon,
  ScheduleIcon: ScheduleIcon,
  AnnouncementIcon: AnnouncementIcon,
  ShoppingBagIcon: ShoppingBagOutlinedIcon,
  CompareArrowsIcon: ImportExportIcon,
  FavoriteBorderIcon: FavoriteBorderIcon,
  SearchIcon: SearchIcon,
  BeenhereOutlinedIcon: BeenhereOutlinedIcon,
  SpaceDashboardIcon: SpaceDashboardIcon,
  AppsIcon: AppsIcon,
  FaListIcon: FaList,
  ShoppingCartOutlinedIcon,
  LocationOnIcon: LocationOnIcon,
  TimeIcon: TimeIcon,
  LocalOfferIcon: LocalOfferIcon,
  EmailIcon: EmailIcon,
  PhoneIcon: PhoneIcon,
  TaskIcon: TaskIcon,
  MeetingRoomIcon: MeetingRoomIcon,
  NoteIcon: NoteIcon,
  KeyboardArrowDownIcon: KeyboardArrowDownIcon,
  CloseIcon: CloseIcon,
  ArrowForwardIcon: ArrowForwardIcon,
  ArrowDownwardIcon: ArrowDownwardIcon,
  ChevronRightIcon: ChevronRightIcon,
  AccountCircleIcon: AccountCircleIcon,
  KeyboardDoubleArrowRightIcon: KeyboardDoubleArrowRightIcon,
  MinimizeIcon: MinimizeIcon,
  OpenInFullIcon: OpenInFullIcon,
  AttachFileIcon: AttachFileIcon,
  AppRegistrationIcon: AppRegistrationIcon,
  AllInclusiveOutlinedIcon: AllInclusiveOutlinedIcon,
  ErrorOutlineIcon: ErrorOutlineIcon,
  DeleteIcon: DeleteIcon,
  DealIcon: LocalOfferOutlinedIcon,
  CallIcon: AddIcCallOutlinedIcon,
  TaskIconNew: AddTaskOutlinedIcon,
  TickIcon: TaskAltOutlinedIcon,
  UntickIcon: CircleOutlinedIcon,
  LockIcon: LockOutlinedIcon,
  WalletOutlinedIcon: WalletOutlinedIcon,
  Transactoions: RepeatOnOutlinedIcon,
};
